// ─────────────────────────────────────────────────────────────────────────────
//  PLANOS NO PAINEL — o que o plano da unidade libera (espelho de
//  utils/planos.js da API; a API é quem TRAVA, aqui só se mostra)
//
//    recurso \ plano        Gerente I.A.  Atendimento I.A.  Conversão  Conversão+  Premium
//    ia_notas (nota/conversas)    ✓             ✓               –          ✓           ✓
//    ia_atendimento (robô)        –             ✓               –          –           ✓
//    campanhas (+ resultados)     –             –               ✓          ✓           ✓
//    avisos                       –             –               ✓          ✓           ✓
//    bi (Painel B.I.)             –             –               –          ✓           ✓
//  Conversão+ = Conversão + Gerente I.A. (+ B.I.): o Premium sem o robô que
//  responde. O Super saiu do catálogo: o código 'super' vale Premium + Delivery.
//  Módulos da equipe: financeiro (module_finance), delivery (module_delivery),
//  Disparo B (module_disparo_b — o antigo "plano B"; só em plano com campanhas),
//  Notificações (module_notifications — mensagens do caixa; sem o campo, fica
//  ligado para quem já configurou o PDV).
//
//  Códigos antigos de Places.plan continuam valendo: basic → Atendimento I.A.
//  (online: o plano pago), standard → Conversão, standard_b → Conversão + B,
//  premium_b → Premium + B, super → Premium + Delivery.
//
//  Sessão: ao entrar numa unidade grava `dir` ({ id, nome, chaves }) e o
//  `nalp` de sempre ('300'/'400'/'900' + '_b' só com Disparo B) — as telas
//  antigas que leem o nalp continuam iguais. O App confere com a API
//  (GET /planos/direitos/:userId) ao abrir e atualiza.
// ─────────────────────────────────────────────────────────────────────────────

export const PLANOS = {
    gerente_ia: { id: 'gerente_ia', nome: 'Gerente I.A.', familia: 'ia', nalp: '300', recursos: ['ia_notas'] },
    atendimento_ia: { id: 'atendimento_ia', nome: 'Atendimento I.A.', familia: 'ia', nalp: '300', recursos: ['ia_notas', 'ia_atendimento'] },
    conversao: { id: 'conversao', nome: 'Conversão', familia: 'turbo', nalp: '400', recursos: ['campanhas', 'avisos'] },
    conversao_plus: { id: 'conversao_plus', nome: 'Conversão+', familia: 'turbo', nalp: '900', recursos: ['campanhas', 'avisos', 'bi', 'ia_notas'] },
    premium: { id: 'premium', nome: 'Premium', familia: 'premium', nalp: '900', recursos: ['campanhas', 'avisos', 'bi', 'ia_notas', 'ia_atendimento'] }
}
export const ORDEM_PLANOS = ['gerente_ia', 'atendimento_ia', 'conversao', 'conversao_plus', 'premium']

const LEGADO = {
    basic: { plano: 'atendimento_ia', b: false },
    standard: { plano: 'conversao', b: false },
    standard_b: { plano: 'conversao', b: true },
    premium: { plano: 'premium', b: false },
    premium_b: { plano: 'premium', b: true },
    super: { plano: 'premium', b: false, delivery: true }
}

// o mesmo cálculo da API (utils/planos.planoDaUnidade)
export function planoDaUnidade(place) {
    const p = place || {}
    const codigo = String(p.plan || '').trim()
    const ss = p.billing && PLANOS[p.billing.plano_id] ? PLANOS[p.billing.plano_id] : null
    let id = null
    let legado = null
    if (PLANOS[codigo]) {
        id = codigo
    } else if (LEGADO[codigo]) {
        legado = codigo
        id = LEGADO[codigo].plano
        if (ss && ss.familia === PLANOS[id].familia) id = ss.id
    } else if (ss) {
        id = ss.id
    }
    const def = id ? PLANOS[id] : null
    const tem = (k) => !!(def && def.recursos.includes(k))
    const bMarcado = typeof p.module_disparo_b === 'boolean' ? p.module_disparo_b : !!(legado && LEGADO[legado].b)
    const financeiro = typeof p.module_finance === 'boolean' ? p.module_finance : p.pdv === 'allegro_auto'
    // antigo Super (código ou plano pago): o Delivery vinha incluso
    const superAntigo = (legado && LEGADO[legado].delivery) || (p.billing && p.billing.plano_id === 'super')
    const delivery = p.module_delivery === true || !!(superAntigo && def)
    const b = bMarcado && tem('campanhas')
    // o hash do token nunca chega ao painel: o legado vale pelo hint / último envio.
    // Token legado em texto (notifications_token), se vier, também conta — igual à API
    const notificacoes = typeof p.module_notifications === 'boolean' ? p.module_notifications : !!(p.notifications_token || p.notifications_token_hash || p.notifications_token_hint || p.notifications_last_sent)
    const chaves = def ? [...def.recursos] : []
    if (b) chaves.push('campanhas_b')
    if (financeiro) chaves.push('financeiro')
    if (delivery && !chaves.includes('delivery')) chaves.push('delivery')
    if (notificacoes) chaves.push('notificacoes')
    return { id, nome: def ? def.nome : null, familia: def ? def.familia : 'sem', legado, chaves, nalp: def ? def.nalp + (b ? '_b' : '') : null }
}

// grava na sessão o plano da unidade que acabou de ser aberta
export function salvarPlanoNaSessao(place) {
    const pl = planoDaUnidade(place)
    try {
        if (pl.nalp) localStorage.setItem('nalp', pl.nalp)
        else localStorage.removeItem('nalp')
        localStorage.setItem('dir', JSON.stringify({ id: pl.id, nome: pl.nome, chaves: pl.chaves }))
    } catch (e) { /* sem storage: as telas caem no nalp */ }
    return pl
}

// o que a API respondeu (GET /planos/direitos) vale mais que o cálculo local
export function salvarDireitosDaApi(plano) {
    if (!plano || !Array.isArray(plano.chaves)) return
    try {
        // unidade sem plano (nalp null): tira o nalp velho, senão as telas
        // antigas que leem o nalp continuam liberando
        if (plano.nalp) localStorage.setItem('nalp', plano.nalp)
        else localStorage.removeItem('nalp')
        localStorage.setItem('dir', JSON.stringify({ id: plano.id || null, nome: plano.nome || null, chaves: plano.chaves }))
        localStorage.setItem('mod_fin', String(plano.chaves.includes('financeiro')))
        localStorage.setItem('mod_del', String(plano.chaves.includes('delivery')))
        localStorage.setItem('mod_not', String(plano.chaves.includes('notificacoes')))
    } catch (e) { /* sem storage */ }
}

// sessão aberta antes desta versão (sem `dir`): deduz pelo nalp e mod_fin
function pelaSessaoAntiga() {
    const nalp = localStorage.getItem('nalp') || ''
    const base = nalp.startsWith('300') ? 'atendimento_ia' : nalp.startsWith('400') ? 'conversao' : nalp.startsWith('900') ? 'premium' : null
    const chaves = base ? [...PLANOS[base].recursos] : []
    if (base && nalp.endsWith('_b') && chaves.includes('campanhas')) chaves.push('campanhas_b')
    const fin = localStorage.getItem('mod_fin')
    if (fin === null ? localStorage.getItem('pdv') === 'allegro_auto' : fin === 'true') chaves.push('financeiro')
    if (localStorage.getItem('mod_del') === 'true' && !chaves.includes('delivery')) chaves.push('delivery')
    if (localStorage.getItem('mod_not') === 'true') chaves.push('notificacoes')
    return { id: base, nome: base ? PLANOS[base].nome : null, chaves }
}

export function direitosDaSessao() {
    try {
        const d = JSON.parse(localStorage.getItem('dir') || 'null')
        if (d && Array.isArray(d.chaves)) return d
    } catch (e) { /* valor inválido: deduz */ }
    return pelaSessaoAntiga()
}

export const temDireito = (chave) => direitosDaSessao().chaves.includes(chave)

// planos que liberam um recurso (vitrine de upgrade)
export const planosCom = (chave) => ORDEM_PLANOS.filter((id) => PLANOS[id].recursos.includes(chave))

// os que liberam SEM tirar nada do plano atual (igual à API): no Conversão+
// o robô que responde pede o Premium; no Gerente I.A., o Atendimento I.A.
export function planosDeUpgrade(chave, atualId) {
    const atual = PLANOS[atualId]
    if (!atual) return planosCom(chave)
    const cobre = planosCom(chave).filter((id) => atual.recursos.every((r) => PLANOS[id].recursos.includes(r)))
    return cobre.length ? cobre : planosCom(chave)
}
